import { PrintDoc } from '../print/PrintDoc';
import { fmt } from '../shared/badges';
import { nomTiers, labelQualite } from '../../lib/dataProvider';
import { attribuerNumero } from '../../lib/souches';

export const BonSortieDirecte = ({ reception: r, onClose }) => (
  <PrintDoc type="Bon de sortie d’huile — remise directe" format="a5"
    numero={attribuerNumero('bon_sortie', `DIRECT-${r.id}`)} date={r.dateTrituration || r.date}
    tiers={nomTiers(r.tiersId)} lignes={[
      ['Nature', 'Huile du client — prestation de trituration'], ['Bon de réception', r.id],
      ['Destination', 'Remise directe au client, sans stockage en cuve'],
      ['Qualité', labelQualite(r.qualite)], ['Quantité remise', `${fmt(r.huileExtraite, 3)} kg`],
      ...(r.immatriculation ? [['Véhicule à la réception', r.immatriculation]] : []),
    ]} mentions="Justificatif de remise de l’huile appartenant au client. Ce bon ne vaut pas reçu de paiement. Réimprimer ne crée aucun mouvement de stock."
    signatures={['Signature — client / réceptionnaire', 'Signature — huilerie']} onClose={onClose} />
);
